import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";

export function* leaveAllianceSaga({ newEmperorId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "leaveAlliance",
      "new-emp-id": newEmperorId
    });

    const { data } = JSON.parse(response.data);

    if (data.success) {
      yield put(actions.updateState({
        alliance: null
      }));

      yield put(actions.closeDialog());
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* foundAllianceSaga({ allianceName }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "foundAlliance",
      "alliance-name": allianceName
    });

    const { data } = JSON.parse(response.data);

    if (data.success && data.alliance) {
      yield put(actions.updateState({
        alliance: data.alliance,
        marketPlaceBlock: data.marketPlaceBlock
      }));

      yield put(actions.closeDialog());
    }

    const { hasFinishedQuest, availableQuests, finishedQuests } = data;
    if (hasFinishedQuest) {
      yield put(actions.updateState({
        hasFinishedQuest,
        availableQuests,
        finishedQuests
      }));

      yield put(actions.updateResources({
        resources: data.resources,
        resourceBalances: data.resourceBalances
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* applyAllianceSaga({ allianceName }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "applyAlliance",
      allianceName
    });

    const { data } = JSON.parse(response.data);

    if (data.success && data.membershipApplication) {
      yield put(actions.updateState({
        membershipApplication: data.membershipApplication
      }));

      yield put(actions.closeDialog());
    } else {
      yield put(actions.setError("Alliance not found"));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* cancelApplicationSaga({ governorateId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "cancelApplication",
      govId: governorateId
    });

    const { data } = JSON.parse(response.data);

    if (data.success) {
      yield put(actions.updateState({
        alliance: data.alliance,
        membershipApplication: data.membershipApplication
      }));
    }

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
  }
}

export function* acceptApplicationSaga({ governorateId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "acceptApplication",
      govId: governorateId
    });

    const { data } = JSON.parse(response.data);

    if (data.success && data.alliance) {
      yield put(actions.updateState({
        alliance: data.alliance,
      }));

      yield put(actions.closeDialog());
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* expelMemberSaga({ governorateId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "expelMember",
      govId: governorateId
    });

    const { data } = JSON.parse(response.data);

    if (data.success) {
      yield put(actions.updateState({
        alliance: data.alliance || null
      }));

      yield put(actions.closeDialog());
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* toggleWarApplicationSaga({ apply }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "toggleWarApplication",
      apply
    });

    const { data } = JSON.parse(response.data);

    if (data.success && data.alliance) {
      yield put(actions.updateState({
        alliance: data.alliance || null
      }));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* editNoteSaga({ noteType, note }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction",
      noteType === "governorate"
        ? { action: "setGovernorateNote", "new-gov-note": note }
        : { action: "setAllianceNote", "alli-note": note });

    const { data } = JSON.parse(response.data);

    if (data.note !== undefined) {
      yield put(actions.updateState({
        note: data.note
      }));
    }

    if (data.alliance) {
      yield put(actions.updateState({
        alliance: data.alliance
      }));
    }

    yield put(actions.closeTooltip());
  } catch (error) {
    console.log(error.message);
  }
}

export function* abdicateSaga({ password, newEmperorId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "abdicate",
      "plr-pass": password,
      "new-emp-id": newEmperorId
    });

    const { data } = JSON.parse(response.data);

    if (data && data.success) {
      window.location.href = `${process.env.REACT_APP_API_URL}/account/display#abdicated`;
    } else {
      yield put(actions.setError("Incorrect password"));
    }
  } catch (error) {
    console.log(error.message);
  }
}

export function* toggleCommanderSaga({ govId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "toggleCommander",
      govId
    });

    const { data } = JSON.parse(response.data);

    yield put(actions.updateState({
      alliance: data.alliance
    }));

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
  }
}

export function* handoverEmperorSaga({ govId }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "handoverEmperor",
      govId
    });

    const { data } = JSON.parse(response.data);

    yield put(actions.updateState({
      alliance: data.alliance
    }));

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
  }
}
